import { Link } from 'react-router-dom'
import { Box, TableCell, Tooltip, Typography } from '@mui/material'
import { Clear, Done } from '@mui/icons-material'

export const CustomTableCell = ({
  value,
  to,
  maxWidth = '250px',
  noWrap = true,
  preserveCase = false,
}: {
  value: string | boolean
  to?: string
  maxWidth?: string,
  noWrap?: boolean
  preserveCase?: boolean
}) => {
  const isBoolean = typeof value === 'boolean'
  return (
    <TableCell align={isBoolean ? 'center' : 'left'}>
      <Box maxWidth={maxWidth} sx={{ display: isBoolean ? 'flex' : 'block', justifyContent: 'center' }}>
        <Tooltip title={isBoolean ? (value ? 'Yes' : 'No') : value} arrow placement={'top-start'}>
          {to ? (
            <Link to={to}>
              <Typography
                variant="body1"
                noWrap={noWrap}
                color={to ? 'primary' : 'black'}
                textTransform={preserveCase ? 'none' : 'capitalize'}
                sx={{ minWidth: '90px' }}
              >
                {value}
              </Typography>
            </Link>
          ) : (
            <Typography
              align={isBoolean ? 'center' : 'left'}
              variant="body1"
              noWrap={noWrap}
              color={to ? 'primary' : 'black'}
              textTransform={preserveCase ? 'none' : 'capitalize'}
            >
              {isBoolean ? value ? <Done color="success" /> : <Clear color="error" /> : value}
            </Typography>
          )}
        </Tooltip>
      </Box>
    </TableCell>
  )
}
